module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_display_GraphicsSolidFill__;